export const renderPrice = (price = 0) => {
  return price.toLocaleString("en-CA", {
    style: "currency",
    currency: "CAD",
  });
};
